import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Snackbar } from "@js/components/snackbar";

import { useGetClientInvitationDetailsQuery } from "../../api";
import { REGISTER_INVITATION_PARAMS } from "../../utils";

export const NEW_EMPLOYER_INVITATION_PARAM =
  REGISTER_INVITATION_PARAMS.NEW_EMPLOYER_INVITATION_KEY;
const NEW_EMPLOYER_INVITATION_COMPANY_NODE = "company_node";

export const useNewClientSignUpInvitation = () => {
  const [searchParams] = useSearchParams();
  const clientInvitationKey = searchParams.get(NEW_EMPLOYER_INVITATION_PARAM);
  const clientCompanyNode = searchParams.get(
    NEW_EMPLOYER_INVITATION_COMPANY_NODE,
  );
  const [isClientInvitation, setIsClientInvitation] = useState(
    Boolean(clientInvitationKey),
  );
  const { data, isLoading } = useGetClientInvitationDetailsQuery(
    { key: clientInvitationKey as string },
    { skip: !clientInvitationKey },
  );

  useEffect(() => {
    if (!isLoading && data?.invitation_error?.length) {
      Snackbar.error(data?.invitation_error, {
        preventDuplicate: true,
      });
      setIsClientInvitation(false);
    }
  }, [data, isLoading]);

  return {
    isClientInvitation,
    isClientCompanyNodePresent: Boolean(clientCompanyNode),
    newClientInvitationData: data?.invitation_error ? undefined : data,
  };
};
